<!--
 * @Author: your name
 * @Date: 2021-11-08 14:54:27
 * @LastEditTime: 2021-11-19 17:25:57
 * @LastEditors: Please set LastEditors
 * @Description: 卡盒授权协议
 * @FilePath: \h5-vip\src\pages\CreditCard\khAuthorizationAgreement.vue
-->
<template>
  <div class="app-container">
    <div class="agreement" v-html="html"></div>
  </div>
</template>

<script>
import { khAuthorizationAgreement } from "@/api/index"
export default {
  name: "",
  data() {
    return {
      html: "",
    };
  },
  created() {
    this.getagreement();
  },
  methods: {
    async getagreement() {
        await khAuthorizationAgreement().then(res => {
          this.html = res.data.content;
        })
    },
  },
};
</script>

<style scoped>
.agreement {
  margin: 10px 10px;
}
</style>
